import { render, staticRenderFns } from "./AsyncForm.vue?vue&type=template&id=122c4a72"
import script from "./AsyncForm.vue?vue&type=script&lang=js"
export * from "./AsyncForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports